import { getVariant } from '@wetransfer/transfer/modules/experiments';

export default class ExperimentSplashCtaTextExperiment {
  static key = 'splash-cta-text-experiment';

  static variations = {
    control: 'false',
    enabled: 'true',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isEnabled(): boolean {
    return this.currentVariant() === this.variations['enabled'];
  }

  static currentVariant(): string {
    return getVariant(this.key, this.variations.control) as string;
  }
}
